import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSignInAlt, FaUserPlus, FaUserCircle, FaSignOutAlt, FaInfoCircle } from 'react-icons/fa';
import '../css/UserModal.css';
import ThemeSwitch from '../components/ThemeSwitch';
import { authAPI } from '../api/api';

const UserModal = ({ open, onClose, props }) => {
  const navigate = useNavigate();
  const [loggedIn, setLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');

  useEffect(() => {
    const user = authAPI.getCurrentUser();
    setLoggedIn(!!user);
    setUser(user);
  }, [open]);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  if (!open) return null;

  const handleLogout = () => {
    authAPI.logout();
    setLoggedIn(false);
    setUser(null);
    onClose && onClose();
    window.location.reload();
  };

  const toggleTheme = () => {
    setTheme(prev => (prev === 'dark' ? 'light' : 'dark'));
  };

  return (
    <div className="user-modal-backdrop" onClick={onClose}>
      <div className="user-modal-dropdown" onClick={e => e.stopPropagation()}>
        <div className="user-modal-header user-modal-header-colored">Fiók műveletek</div>
        <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom: 12}}>
          <span style={{fontWeight:'bold', color: theme === 'dark' ? '#fff' : '#000'}}>Téma:</span>
          <ThemeSwitch theme={theme} onToggle={toggleTheme} />
        </div>
        {!loggedIn ? (
          <>
            <div style={{display:'flex', alignItems:'center', gap:8,}}>
              <FaInfoCircle style={{fontSize:'1.3rem'}} />
              <span>Kérlek jelentkezz be hogy<br />láthasd a fiók műveleteket!</span>
            </div>
            <button className="user-modal-btn" onClick={() => { navigate('/auth'); onClose(); }}>
              <FaSignInAlt className="user-modal-btn-icon" /> Bejelentkezés
            </button>
            <button className="user-modal-btn" onClick={() => { navigate('/auth?register'); onClose(); }}>
              <FaUserPlus className="user-modal-btn-icon" /> Regisztráció
            </button>
          </>
        ) : (
          <>
            <button onClick={() => { navigate('/profile'); onClose(); }} className="user-modal-btn">
              <FaUserCircle className="user-modal-btn-icon" /> Profilom
            </button>
            <button onClick={handleLogout} className="user-modal-btn">
              <FaSignOutAlt className="user-modal-btn-icon" /> Kijelentkezés
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default UserModal; 